import Link from '@components/v2/ui/Link/Link';
import Typography from '@components/v2/ui/Typography/Typography';
import { privacyPoliticsUrl, termsOfUseUrl } from '../../components/PrivacyPolitics';
import LangEnum from '../../lang/LangEnum';
import { useTranslation } from '../translation/TranslationContext';

const SignUpTermsNotice = () => {
  const { translate } = useTranslation();

  return (
    <Typography variant="body2" color="text.secondary" align="center">
      {translate(LangEnum.SIGN_UP_NEW_ACCOUNT_TERMS_PREFIX)}
      <Link href={termsOfUseUrl} color="text.primary">
        {translate(LangEnum.PRIVACY_POLITICS_TERMS_OF_USE)}
      </Link>
      {translate(LangEnum.SIGN_UP_NEW_ACCOUNT_TERMS_MIDDLE)}
      <Link href={privacyPoliticsUrl} color="text.primary">
        {translate(LangEnum.PRIVACY_POLITICS_PRIVACY_POLICY)}
      </Link>
      {translate(LangEnum.SIGN_UP_NEW_ACCOUNT_TERMS_SUFFIX)}
    </Typography>
  );
};

export default SignUpTermsNotice;
